import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {Divider} from "@mui/material";
import {useNavigate} from "react-router-dom";
import i18n from "../utils/i18n";
import MenuIcon from '@mui/icons-material/Menu';

export default function MenuButton({sx}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  }
  const handleClickUkr = () => {
    i18n.changeLanguage('uk-UA');
    setAnchorEl(null);
  };
  const handleClickEn = () => {
    i18n.changeLanguage('en-US');
    setAnchorEl(null);
  };
  const handleClickAbout = () => {
    // window.open('/about-' + i18n.language + '.html', '_blank');
    navigate('/about');
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={sx}
      >
        <MenuIcon/>
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={handleClickUkr}>Українською</MenuItem>
        <MenuItem onClick={handleClickEn}>English</MenuItem>
        <Divider />
        <MenuItem onClick={handleClickAbout}>{i18n.t('aboutMenuItemText')}</MenuItem>
      </Menu>
    </>
  );
}